import api from './api';

export interface SummarySectionConfig {
  type: string;
  name: string;
  label: string;
}

export type SummaryTypeKind = 'psychiatric' | 'titration' | 'titration_followup';

/** Titration summaries have no AI summary sections — only a PDF layout. A follow-up
 *  uses its own 'titration_followup' layout when the tenant has one, else 'titration'. */
export const isTitrationKind = (kind: SummaryTypeKind): boolean =>
  kind === 'titration' || kind === 'titration_followup';

export interface SummaryType {
  id: number;
  name: string;
  tenant_id: number;
  type: SummaryTypeKind;
  summary_sections: SummarySectionConfig[] | null;
  pdf_layout: any[] | null;
  created_at: string;
  updated_at: string;
}

export interface SummaryTypeCreate {
  name: string;
  tenant_id: number;
  type?: SummaryTypeKind;
  summary_sections?: SummarySectionConfig[] | null;
  pdf_layout?: any[] | null;
}

export interface SummaryTypeUpdate {
  name?: string;
  type?: SummaryTypeKind;
  summary_sections?: SummarySectionConfig[] | null;
  pdf_layout?: any[] | null;
}

export const summaryTypeService = {
  async getSummaryTypes(tenantId?: number): Promise<SummaryType[]> {
    const params = tenantId ? { tenant_id: tenantId } : {};
    const response = await api.get('/summary-types/', { params });
    return response.data;
  },

  async getSummaryType(id: number): Promise<SummaryType> {
    const response = await api.get(`/summary-types/${id}`);
    return response.data;
  },

  async createSummaryType(data: SummaryTypeCreate): Promise<SummaryType> {
    const response = await api.post('/summary-types/', data);
    return response.data;
  },

  async updateSummaryType(id: number, data: SummaryTypeUpdate): Promise<SummaryType> {
    const response = await api.put(`/summary-types/${id}`, data);
    return response.data;
  },

  async deleteSummaryType(id: number): Promise<void> {
    await api.delete(`/summary-types/${id}`);
  },
};
